import { ComIbmCommerceRestMemberHandlerDeleteUserRelDetails } from './data-contracts';
import { HttpClient, RequestParams, TraceDataType } from './http-client';

import { loggerCan } from '@/data/utils/loggerUtil';
import { logger } from '@/logging/logger';

export class DeleteUserRelation<SecurityDataType = unknown> {
	http: HttpClient<SecurityDataType>;

	constructor(http: HttpClient<SecurityDataType>) {
		this.http = http;
	}

	/**
	 * No description
	 *
	 * @tags Delete User Relation
	 * @name PersonUserrelDelete
	 * @summary Delete User Relation
	 * @request DELETE:/store/{storeId}/person/userrel/{userRelId}
	 * @secure
	 * @response `200` `ComIbmCommerceRestMemberHandlerDeleteUserRelDetails` The requested completed successfully.
	 * @response `400` `void` Bad request. The request could not be understood by the server due to malformed syntax.
	 * @response `401` `void` Not authenticated. The user session is not valid.
	 * @response `403` `void` The user is not authorized to perform the specified request.
	 * @response `404` `void` The specified resource could not be found.
	 * @response `500` `void` Internal server error. For details, see the server log files.
	 */
	personUserrelDelete = (
		storeId: string,
		userRelId: string,
		query?: {
			/** The response format. Valid values are json and xml. If the request contains an input body, it must use the format specified in responseFormat. If the responseFormat is not specified, the accept  HTTP header determines the format of the response. If the accept  HTTP header is not specified then default response format is json. */
			responseFormat?: 'xml' | 'json';
		},
		params: RequestParams = {}
	) => {
		const { _requestId: requestId, skipErrorLogging, ..._params } = params as any;
		let traceData: TraceDataType | undefined;

		if (
			loggerCan('trace') &&
			(!this.http.traceDetails || this.http.traceDetails['personUserrelDelete'])
		) {
			traceData = {
				requestId,
				msg: 'API request',
				url: `${this.http.baseUrl}/store/${storeId}/person/userrel/${userRelId}`,
				params: _params,
				query: query,
				methodName: 'personUserrelDelete',
			};
			logger.trace(traceData);
		}
		return this.http.request<ComIbmCommerceRestMemberHandlerDeleteUserRelDetails, void>({
			path: `/store/${storeId}/person/userrel/${userRelId}`,
			method: 'DELETE',
			query: query,
			secure: true,
			format: params.format ?? 'json',
			storeId,
			traceData,
			skipErrorLogging,
			..._params,
		});
	};
}
